import ProductHero from './ProductHero.jsx';
import BuiltToGrow from './BuiltToGrow.jsx';
import KeyBenefits from './KeyBenefits.jsx';
import IdealFor from './IdealFor.jsx';

/** Alpha ESS product page. */
export default function AlphaEss() {
  return (
    <>
      <ProductHero />
      <BuiltToGrow />
      <KeyBenefits />
      <hr />
      <IdealFor />
    </>
  );
}
